import startOfDay from "date-fns/startOfDay";
import addMinutes from "date-fns/addMinutes";

const currentDate = new Date();

const getDateFromMinutes = (minutes: number, date?: Date) =>
  addMinutes(startOfDay(date ?? currentDate), minutes);

export { getDateFromMinutes };
